/// <amd-module name="Search/WorkItem/Components/LeftPane/Snippet" />
import * as React from "react";
import { ResultsViewConstants } from "Search/WorkItem/Constants";
import { sanitizeHtml } from "Search/WorkItem/Utils";
import { IHighlightFragment } from "Search/WorkItem/Flux/Stores/SnippetFragmentCache";

export interface ISnippetProps {
    aggregatedHits: { [key: string]: IHighlightFragment };
}

export const Snippet = (props: ISnippetProps) => {
    const fragmentFieldReferenceNames =
        Object
            .keys(props.aggregatedHits)
            .filter((k, j) => {
                return ResultsViewConstants.MetadataFields.indexOf(k.toLowerCase()) < 0;
            });

    if (fragmentFieldReferenceNames.length > 0) {
        return (
            <div className="workitem-snippet scroll-hidden">
                {
                    fragmentFieldReferenceNames.map((refName, index) => {
                        const fieldNameToLower = props.aggregatedHits[refName].name.toLocaleLowerCase();
                        let displayName: string = ResultsViewConstants.FieldNameToDisplayName[fieldNameToLower];

                        displayName = displayName ? displayName : props.aggregatedHits[refName].name;
                        return (
                            <span key={index}>
                                <span className="workitem-snippet-prop-label">{displayName}: </span>
                                <span dangerouslySetInnerHTML={{
                                    __html: props.aggregatedHits[refName].highlights.map((v, idx) => {
                                        return sanitizeHtml(v);
                                    }).join("... ") + (index < fragmentFieldReferenceNames.length - 1 ? "..." : "")
                                }} />
                            </span>
                        )
                    })
                }
            </div>
        );
    };

    return null;
}
